<template>
	<div>
		<div class="help-aside">
			<div class="help-aside-inner" style="top: 0;">
				<dl class="help-links">
					<dt>关于我们</dt>
          <dd :class="{current:tabStr === '/notice'}">
          	<router-link :to="{path:'/notice'}">
          			平台公告
          	</router-link>
          </dd>
					<dd :class="{current:tabStr === '/aboutMe'}">
						<router-link :to="{path:'/aboutMe'}">
								公司简介
						</router-link>
					</dd>
					<dd :class="{current:tabStr === '/contact'}">
						<router-link :to="{path:'/contact'}">
								联系我们
						</router-link>
					</dd>

					<dd :class="{current:tabStr === '/opinion'}">
						<router-link :to="{path:'/opinion'}">
								意见反馈
						</router-link>
					</dd>
				</dl>
				<dl class="help-links">
					<dd :class="{current:tabStr === '/problem'}">
						<router-link :to="{path:'/problem'}">
								常见问题
						</router-link>
					</dd>
					<dd :class="{current:tabStr === '/flow'}">
						<router-link :to="{path:'/flow'}">
								回收流程
						</router-link>
					</dd>
					<dd :class="{current:tabStr === '/terrace'}" >
						<router-link :to="{path:'/terrace'}">
								用户服务协议
						</router-link>
					</dd>
					<dd :class="{current:tabStr === '/terraceUser'}">
						<router-link :to="{path:'/terraceUser'}">
								隐私政策
						</router-link>
					</dd>
					<dd :class="{current:tabStr === '/declrea'}">
						<router-link :to="{path:'/declrea'}">
								礼品卡回收说明
						</router-link>
					</dd>
					<dd :class="{current:tabStr === '/deal'}">
						<router-link :to="{path:'/deal'}">
								礼品卡转让协议
						</router-link>
					</dd>
				</dl>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"About",
		data(){
			return{
				tabStr:""
			}
		},
		created(){
			this.tabStr = window.location.hash.replace(/[#]/g, '')
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/about/index.vue